import * as stylex from '@stylexjs/stylex'

export const zIndexValues = {
  appBar: 1100,
  drawer: 1200,
  fab: 1050,
  mobileStepper: 1000,
  modal: 1300,
  snackbar: 1400,
  speedDial: 1050,
  tooltip: 1500,
}

export const zIndex = stylex.defineVars({
  appBar: stylex.types.number(zIndexValues.appBar),
  drawer: stylex.types.number(zIndexValues.drawer),
  fab: stylex.types.number(zIndexValues.fab),
  mobileStepper: stylex.types.number(zIndexValues.mobileStepper),
  modal: stylex.types.number(zIndexValues.modal),
  snackbar: stylex.types.number(zIndexValues.snackbar),
  speedDial: stylex.types.number(zIndexValues.speedDial),
  tooltip: stylex.types.number(zIndexValues.tooltip),
})
export type ZIndex = typeof zIndex
